<template>
  <div class="system-settings">
    <!-- ページヘッダー -->
    <PageHeader>システム設定</PageHeader>

    <!-- タブナビゲーション -->
    <AppTabs
      :tabs="tabs"
      v-model="currentTab"
    />

    <!-- タブコンテンツ -->
    <TabContentArea :active-tab="currentTab">
      <template #collection>
        <div class="tab-content-section">
          <CollectionInfoMenuView
            @navigate-to-setting="handleNavigateToSetting"
          />
        </div>
      </template>

      <template #hidden-stations>
        <div class="tab-content-section">
          <System />
        </div>
      </template>
    </TabContentArea>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import PageHeader from '@/components/molecules/PageHeader.vue'
import AppTabs from '@/components/organisms/AppTabs.vue'
import TabContentArea from '@/components/organisms/TabContentArea.vue'
import CollectionInfoMenuView from './CollectionInfoMenuView.vue'
import System from '@/components/pages/System.vue'

const props = defineProps({
  activeTab: {
    type: String,
    default: 'collection'
  }
})

const emit = defineEmits(['tab-changed', 'navigate-to-setting'])

const tabs = [
  {
    key: 'collection',
    title: '収集情報設定',
    icon: 'bi bi-truck'
  },
  {
    key: 'hidden-stations',
    title: '非表示集積所設定',
    icon: 'eye-slash'
  }
]

const currentTab = computed({
  get() {
    return props.activeTab
  },
  set(value) {
    emit('tab-changed', value)
  }
})

const handleNavigateToSetting = (route) => {
  emit('navigate-to-setting', route)
}
</script>

<style scoped>
.system-settings {
  padding: 20px;
}



.tab-content-wrapper {
  margin-top: 20px;
  border: 1px solid #dee2e6;
  border-radius: 0 0 0.375rem 0.375rem;
  background-color: #fff;
}

.tab-content-section {
  padding: 10px;
  min-height: 400px;
}

.tab-content-section h4 {
  margin-bottom: 20px;
  color: #333;
}

/* System.vueのヘッダーとの重複を避けるため、パディングを調整 */
.tab-content-section .container-fluid {
  padding: 0;
}
</style>
